export default "__VITE_ASSET__4HTwd$E7__"